import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { fetchSearchPatient, fetchPatientDetails, createPatientAPI, searchPatientByProgram, fetchPatientMemberInPartner, getFatchPhoneNumberAPI } from '../../../utilities/API/patientSearch/patientSearch';
import { isLoader } from "../../../constant/Constants"
import { response } from '../smartyStreetSlice';

export const searchPartnerPatient = createAsyncThunk(
    'fetchSearchPatient', fetchSearchPatient
)
export const getPatientDetails = createAsyncThunk(
    'fetchPatientDetails', fetchPatientDetails
)
export const createPatientInPartner = createAsyncThunk(
    'createPatientAPI', createPatientAPI
)
export const getSearchPatientByProgram = createAsyncThunk(
    'searchPatientByProgram', searchPatientByProgram
)
export const getPatientMemberInPartner = createAsyncThunk(
    'fetchPatientMemberInPartner', fetchPatientMemberInPartner
)
export const getFatchPhoneNumber = createAsyncThunk(
    'getFatchPhoneNumber', getFatchPhoneNumberAPI
)


const initialState = {
    searchPatientDetails: {
        isSSN: true,
        firstName: '',
        lastName: '',
        dob: '',
        ssn: '',
        maskedSSN: '',
        alienNumber: '',
        maskedAlien: '',
    },
    initialSearch: true,
    newPatient: false,
    getMemberLookupData: false,
    getPartnerMemberLookupData: false,
    IsPatientLocked:false,
    routeToPrescreen: false,
    dyNumber:'',
    createNewPatientModal: false,
    patientDetails: {
        isSSN: false,
        patientId: '',
        patientIdFAF: '',
        patientIdCPR: '',
        patientIdCASE: '',
        firstName: '',
        lastName: '',
        dob: '',
        ssn: '',
        alienNumber: '',
        phoneNumber: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipCode: '',
        email: '',
        fullAddress: '',
        caseID: ""
    },
    displayPatientCard: false,
    patientInformation: {
        Program: '',
        existingPatient: false,
        programSpecificPatientId: '',
        partnerPatientId: '',
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        hasGuardian: false,
        isSSN: false,
        ssn: '',
        alienNumber: '',
        address: {
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            zipCode: '',
            smartyStreetMatches: {
                NoMatch: false,
                PartialMatch: false,
                SecInfoNotMatch: false,
                ExactMatch: false,
            },
            ss_msg_cls: '',
            ss_msg: '',
            isAddressVerified: false
        },
        contactDetails: {
            methodOfContact: '',
            preferedLanguage: '',
            email: '',
            emailType: '',
            emailOwner: '',
            phoneType: '',
            phoneNumber: '',
            contactSequence: '',
        },
        guardianDetails: {
            firstName: '',
            lastName: '',
            suffix: '',
            ssn: '',
            alienNumber: '',
            dateOfBirth: '',
            relationshipToPatient: '',
            employementStatus: '',
            email: '',
            emailType: '',
            isAddressSameAsPatient: true,
            isPhoneNumberSameAsPatient: true,
            address: {
                isGuardianAddressVerified: false,
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipCode: '',
                smartyStreetMatches: {
                    NoMatch: false,
                    PartialMatch: false,
                    SecInfoNotMatch: false,
                    ExactMatch: false,
                },
            },
            PhoneCommunication: {
                phoneNumber: '',
                phoneType: '',
            }
        },
        payableInformations:{
            firstName: '',
            lastName: '',
            address: {
                isPayableAddressVerified: false,
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipCode: '',
                smartyStreetMatches: {
                    NoMatch: false,
                    PartialMatch: false,
                    SecInfoNotMatch: false,
                    ExactMatch: false,
                },
                ss_msg_cls: '',
                ss_msg: '',

            }
        },
        additionalInformation: {
            gender: '',
            employementStatus: '',
            veteran: '',
            maritalStatus: '',
            housHoldSize: '',
            race: [],
            raceOther: "",
            hispanicOrgin: '',
            copayPrograms: '',
            copayProgramsChecked: false,
        },
        applicantInfo: {
            relationshipToPatient: "",
            applicantFirstName: "",
            applicantLastName: "",
            applicantPhoneNumber: ""
        },
        referredBy: "",
        referredOther: "",
        healthCare: {
            healthCareProfessionalFirstName: "",
            healthCareProfessionalLastName: "",
            healthCareProfessionalFacilityName: "",
            healthCareProfessionalPosition: "",
            healthCareFacilityName: "",
            healthCareAddressLine1: "",
            healthCareAddressLine2: "",
            healthCareCity: "",
            healthCareState: "",
            healthCareZipcode: "",
            healthCarePhoneNumber: "",
            healthCareEmail: "",
            healthCareEmailType: "",
            sameAsHealthCare: false,
            smartyStreetMatches: {
                NoMatch: false,
                PartialMatch: false,
                SecInfoNotMatch: false,
                ExactMatch: false,
            },
        },
        ePayment: ""
    },
    authorizedPerson: {
        0: {
            firstName: { value: "", isValid: true },
            lastName: { value: "", isValid: true },
            suffix: { value: "", isValid: true },
            relationshipToPatient: { value: "", isValid: true },
            addressLine1: { value: "", isValid: true },
            addressLine2: { value: "", isValid: true },
            city: { value: "", isValid: true },
            state: { value: "", isValid: true },
            zipcode: { value: "", isValid: true },
            phoneType: { value: "", isValid: true },
            phoneNumber: { value: "", isValid: true },
            isAddressChecked: true,
            isPhoneNumberChecked: true,
            isAddressVerified: false,
            isCopySent: false,
            email: { value: "", isValid: true },
            hasDuplicate: false,
            smartyStreetMatches: {
                NoMatch: false,
                PartialMatch: false,
                SecInfoNotMatch: false,
                ExactMatch: false,
            },
            ss_msg_cls: '',
            ss_msg: '',
        }
    },
    isAuthorizedPersonAvailable: false,
    insurance: {
        primaryInsurance: { value: "", isValid: true, isOther: false },
        planType: { value: "", isValid: true },
        policyID: { value: "", isValid: true },
        insuranceType: { value: "", isValid: true },
        phoneNumber: { value: "", isValid: true },
        subscriberName: { value: "", isValid: true },
        groupNumber: { value: "", isValid: true },
        DOB: { value: "", isValid: true },
        medicareSupplement: { checked: false },
        secondaryInsurance: { checked: false },
        medicarePart: { checked: false },
        isSecondaryInsurance: { value: "", isValid: true, isOther: false }
    },
    allowCaseCreation : true

}


const patientSearchSlice = createSlice({
    name: 'patientSearch',
    initialState,
    reducers: {
        resetPatientSearch: (state, action) => {
            state.allowCaseCreation = false
            state.searchPatientDetails = {
                isSSN: true,
                firstName: '',
                lastName: '',
                dob: '',
                ssn: '',
                maskedSSN: '',
                alienNumber: '',
                maskedAlien: '',
            }
            state.initialSearch = true
            state.newPatient = false
            state.IsPatientLocked=false
            state.getMemberLookupData = false
            state.routeToPrescreen = false
            state.createNewPatientModal = false
            state.patientDetails = {
                isSSN: false,
                patientId: '',
                patientIdFAF: '',
                patientIdCPR: '',
                patientIdCASE: '',
                firstName: '',
                lastName: '',
                dob: '',
                ssn: '',
                alienNumber: '',
                phoneNumber: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipCode: '',
                email: '',
                fullAddress: '',
                caseID : ""
            }
            state.displayPatientCard = false
            state.patientInformation = {
                Program: '',
                existingPatient: false,
                programSpecificPatientId: '',
                partnerPatientId: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                hasGuardian: false,
                isSSN: false,
                ssn: '',
                alienNumber: '',
                address: {
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    state: '',
                    zipCode: '',
                    smartyStreetMatches: {
                        NoMatch: false,
                        PartialMatch: false,
                        SecInfoNotMatch: false,
                        ExactMatch: false,
                    },
                    ss_msg_cls: '',
                    ss_msg: '',
                    isAddressVerified: false
                },
                contactDetails: {
                    methodOfContact: '',
                    preferedLanguage: '',
                    email: '',
                    emailType: '',
                    emailOwner: '',
                    phoneType: '',
                    phoneNumber: '',
                    contactSequence: '',
                },
                guardianDetails: {
                    firstName: '',
                    lastName: '',
                    suffix: '',
                    ssn: '',
                    alienNumber: '',
                    dateOfBirth: '',
                    relationshipToPatient: '',
                    employementStatus: '',
                    email: '',
                    emailType: '',
                    isAddressSameAsPatient: true,
                    isPhoneNumberSameAsPatient: true,
                    address: {
                        isGuardianAddressVerified: false,
                        addressLine1: '',
                        addressLine2: '',
                        city: '',
                        state: '',
                        zipCode: '',
                        smartyStreetMatches: {
                            NoMatch: false,
                            PartialMatch: false,
                            SecInfoNotMatch: false,
                            ExactMatch: false,
                        },
                    },
                    PhoneCommunication: {
                        phoneNumber: '',
                        phoneType: '',
                    }
                },
                payableInformations:{
                    firstName: '',
                    lastName: '',
                    address: {
                        isPayableAddressVerified: false,
                        addressLine1: '',
                        addressLine2: '',
                        city: '',
                        state: '',
                        zipCode: '',
                        smartyStreetMatches: {
                            NoMatch: false,
                            PartialMatch: false,
                            SecInfoNotMatch: false,
                            ExactMatch: false,
                        },
                        ss_msg:"",
                        ss_msg_cls: "",
                    },
               
                },
                additionalInformation: {
                    gender: '',
                    employementStatus: '',
                    veteran: '',
                    maritalStatus: '',
                    housHoldSize: '',
                    race: [],
                    raceOther: "",
                    hispanicOrgin: '',
                    copayPrograms: '',
                    copayProgramsChecked: false,
                },
                applicantInfo: {
                    relationshipToPatient: "",
                    applicantFirstName: "",
                    applicantLastName: "",
                    applicantPhoneNumber: ""
                },
                referredBy: "",
                referredOther: "",
                healthCare: {
                    healthCareProfessionalFirstName: "",
                    healthCareProfessionalLastName: "",
                    healthCareProfessionalFacilityName: "",
                    healthCareProfessionalPosition: "",
                    healthCareFacilityName: "",
                    healthCareAddressLine1: "",
                    healthCareAddressLine2: "",
                    healthCareCity: "",
                    healthCareState: "",
                    healthCareZipcode: "",
                    healthCarePhoneNumber: "",
                    healthCareEmail: "",
                    healthCareEmailType: "",
                    sameAsHealthCare: false,
                    smartyStreetMatches: {
                        NoMatch: false,
                        PartialMatch: false,
                        SecInfoNotMatch: false,
                        ExactMatch: false,
                    },
                },
                ePayment: ""
            }
            state.authorizedPerson = {
                0: {
                    firstName: { value: "", isValid: true },
                    lastName: { value: "", isValid: true },
                    suffix: { value: "", isValid: true },
                    relationshipToPatient: { value: "", isValid: true },
                    addressLine1: { value: "", isValid: true },
                    addressLine2: { value: "", isValid: true },
                    city: { value: "", isValid: true },
                    state: { value: "", isValid: true },
                    zipcode: { value: "", isValid: true },
                    phoneType: { value: "", isValid: true },
                    phoneNumber: { value: "", isValid: true },
                    isAddressChecked: true,
                    isPhoneNumberChecked: true,
                    isAddressVerified: false,
                    isCopySent: false,
                    email: { value: "", isValid: true },
                    hasDuplicate: false,
                    smartyStreetMatches: {
                        NoMatch: false,
                        PartialMatch: false,
                        SecInfoNotMatch: false,
                        ExactMatch: false,
                    },
                    ss_msg_cls: '',
                    ss_msg: '',
                }
            }
            state.isAuthorizedPersonAvailable = false
            state.insurance = {
                primaryInsurance: { value: "", isValid: true, isOther: false },
                planType: { value: "", isValid: true },
                policyID: { value: "", isValid: true },
                insuranceType: { value: "", isValid: true },
                phoneNumber: { value: "", isValid: true },
                subscriberName: { value: "", isValid: true },
                groupNumber: { value: "", isValid: true },
                DOB: { value: "", isValid: true },
                medicareSupplement: { checked: false },
                secondaryInsurance: { checked: false },
                medicarePart: { checked: false },
                isSecondaryInsurance: { value: "", isValid: true, isOther: false }
            }

        },
        setAllowCaseCreation : (state,action)=>{
            state.allowCaseCreation = action.payload
        },
        setStoreSearchPatientDetails: (state, action) => {
            state.searchPatientDetails = action.payload;
        },
        setStoreInitialSearch: (state, action) => {
            state.initialSearch = action.payload;
        },
        setStoreDisplayPatientCard: (state, action) => {
            state.displayPatientCard = action.payload;
        },
        setStoreCreateNewPatientModal: (state, action) => {
            state.createNewPatientModal = action.payload;
        },
        setGetMemberLookupData: (state, action) => {
            state.getMemberLookupData = action.payload;
        },
        setGetPartnerMemberLookupData: (state, action) => {
            state.getPartnerMemberLookupData = action.payload;
        },
        setRouteToPrescreen: (state, action) => {
            state.routeToPrescreen = action.payload;
        },
        setProgramSpecificPatientId: (state, action) => {
            if (action.payload.program == 'CPR') {
                state.patientDetails.patientIdCPR = action.payload.patientId;
            } else {
                state.patientDetails.patientIdFAF = action.payload.patientId;
            }
        },
        IsPatientLockedReset:(state,action)=>{
              state.IsPatientLocked =action.payload
        },
        preQualData: (state, action) => {
            state.patientInformation.address.addressLine1 = action.payload.addressLine1.value
            state.patientInformation.address.addressLine2 = action.payload.addressLine2.value
            state.patientInformation.address.city = action.payload.city.value
            state.patientInformation.address.state = action.payload.state.value
            state.patientInformation.address.zipCode = action.payload.zipCode.value
            state.patientInformation.address.smartyStreetMatches.ExactMatch = action?.payload?.smartyStreetMatches?.ExactMatch || false
            state.patientInformation.address.smartyStreetMatches.NoMatch = action?.payload?.smartyStreetMatches?.NoMatch || false
            state.patientInformation.address.smartyStreetMatches.PartialMatch = action?.payload?.smartyStreetMatches?.PartialMatch || false
            state.patientInformation.address.smartyStreetMatches.SecInfoNotMatch = action?.payload?.smartyStreetMatches?.SecInfoNotMatch || false
            state.patientInformation.address.ss_msg_cls = action.payload.ss_msg_cls
            state.patientInformation.address.ss_msg = action.payload.ss_msg
            state.patientInformation.address.isAddressVerified = action.payload.isvalidAddress
        },
        personalInfoData: (state, action) => {
            state.patientInformation.address = {
                addressLine1: action.payload.addressLine1.value,
                addressLine2: action.payload.addressLine2.value,
                city: action.payload.city.value,
                state: action.payload.state.value,
                zipCode: action.payload.zipcode.value
            }
            state.patientInformation.contactDetails = {
                methodOfContact: action.payload.contactby.value,
                preferedLanguage: action.payload.preferedLanguage.value,
                email: action.payload.email.value,
                emailType: action.payload.emailType.value,
                emailOwner: action.payload.emailOwner.value,
                phoneType: action.payload.phoneType.value,
                phoneNumber: action.payload.phoneNumber.value,
                contactSequence: action.payload.contactSequence.value,
            }
            state.patientInformation.guardianDetails = {
                firstName: action.payload.guardianFirstName.value,
                lastName: action.payload.guardianLastName.value,
                suffix: action.payload.guardianSuffix.value,
                ssn: action.payload.guardianSSN.value,
                alienNumber: action.payload.guardianAlien.value,
                dateOfBirth: action.payload.guardianDOB.value,
                relationshipToPatient: action.payload.guardianRelationshipToPatient.value,
                employementStatus: action.payload.guardianEmployment.value,
                email: action.payload.guardianEmail.value,
                emailType: action.payload.guardianEmailType.value,
                isAddressSameAsPatient: action.payload.isAddressChecked,
                isPhoneNumberSameAsPatient: action.payload.isPhoneNumberChecked,
                address: {
                    isGuardianAddressVerified: action.payload.isGuardianAddressVerified,
                    addressLine1: action.payload.guardianAddressLine1.value,
                    addressLine2: action.payload.guardianAddressLine2.value,
                    city: action.payload.guardianCity.value,
                    state: action.payload.guardianState.value,
                    zipCode: action.payload.guardianZipcode.value,
                    smartyStreetMatches: {
                        NoMatch: action?.payload?.guardian.smartyStreetMatches?.NoMatch,
                        PartialMatch: action?.payload?.guardian.PartialMatch?.NoMatch,
                        SecInfoNotMatch: action?.payload?.guardian.SecInfoNotMatch?.NoMatch,
                        ExactMatch: action?.payload?.guardian.ExactMatch?.NoMatch,
                    }
                },
                PhoneCommunication: {
                    phoneNumber: action.payload.guardianPhoneNumber.value,
                    phoneType: action.payload.guardianPhoneType.value,
                }
            }
            state.patientInformation.payableInformations={
                firstName: action.payload.PayableToFirstName.value,
                lastName: action.payload.PayableToLastName.value,
                address: {
                    isPayableAddressVerified:action.payload.isPayableAddressVerified ,
                    addressLine1: action.payload.PayableAddressLine1.value,
                    addressLine2: action.payload.PayableAddressLine2.value,
                    city: action.payload.PayableCity.value,
                    state: action.payload.PayableState.value,
                    zipCode: action.payload.PayableZipCode.value,
                    smartyStreetMatches: {
                        NoMatch: action.payload.payable.smartyStreetMatches.NoMatch,
                        PartialMatch: action.payload.payable.smartyStreetMatches.PartialMatch,
                        SecInfoNotMatch: action.payload.payable.smartyStreetMatches.SecInfoNotMatch,
                        ExactMatch: action.payload.payable.smartyStreetMatches.ExactMatch,
                    },
                    ss_msg:action.payload.payable.ss_msg,
                    ss_msg_cls: action.payload.payable.ss_msg_cls,
                }
            }
            state.patientInformation.additionalInformation = {
                gender: action.payload.gender.value,
                employementStatus: action.payload.employementStatus.value,
                veteran: action.payload.veteran.value,
                maritalStatus: action.payload.maritalStatus.value,
                housHoldSize: action.payload.householdSize.value,
                race: action.payload.race,
                raceOther: action.payload.raceOther.value,
                hispanicOrgin: action.payload.origin.value,
                copayPrograms: action.payload.copayPrograms.isChecked ? action.payload.copayPrograms.value : '',
                copayProgramsChecked: action.payload.copayPrograms.isChecked,
            }
            state.patientInformation.applicantInfo = {
                relationshipToPatient: action.payload.relationshipToPatient.value,
                applicantFirstName: action.payload.applicantFirstName.value,
                applicantLastName: action.payload.applicantLastName.value,
                applicantPhoneNumber: action.payload.applicantPhoneNumber.value
            }
            state.patientInformation.referredBy = action.payload.referredBy.value
            state.patientInformation.referredOther = action.payload.referredOther.value
            state.patientInformation.healthCare = {
                healthCareProfessionalFirstName: action.payload.healthCareProfessionalFirstName.value,
                healthCareProfessionalLastName: action.payload.healthCareProfessionalLastName.value,
                healthCareProfessionalFacilityName: action.payload.healthCareProfessionalFacilityName.value,
                healthCareProfessionalPosition: action.payload.healthCareProfessionalPosition.value,
                healthCareFacilityName: action.payload.healthCareFacilityName.value,
                healthCareAddressLine1: action.payload.healthCareAddressLine1.value,
                healthCareAddressLine2: action.payload.healthCareAddressLine2.value,
                healthCareCity: action.payload.healthCareCity.value,
                healthCareState: action.payload.healthCareState.value,
                healthCareZipcode: action.payload.healthCareZipcode.value,
                healthCarePhoneNumber: action.payload.healthCarePhoneNumber.value,
                healthCareEmail: action.payload.healthCareEmail.value,
                healthCareEmailType: action.payload.healthCareEmailType.value,
                sameAsHealthCare: action.payload.sameAsHealthCare,
                smartyStreetMatches: {
                    NoMatch: action?.payload?.healthCare.smartyStreetMatches?.NoMatch,
                    PartialMatch: action?.payload?.healthCare.PartialMatch?.NoMatch,
                    SecInfoNotMatch: action?.payload?.healthCare.SecInfoNotMatch?.NoMatch,
                    ExactMatch: action?.payload?.healthCare.ExactMatch?.NoMatch,
                }
            }
            state.patientInformation.ePayment = action.payload.ePayment.value
        },
        authorizedPersonData: (state, action) => {
            state.authorizedPerson = action?.payload?.authorizedPersonInfo
            state.isAuthorizedPersonAvailable = action?.payload?.isAuthorized
        },
        insuranceInfoData: (state, action) => {
            state.insurance = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(searchPartnerPatient.pending, (state, action) => {
            })
            .addCase(searchPartnerPatient.fulfilled, (state, action) => {
                let response = action.payload;
                if (response?.ResponseDetails?.ResponseCode == 'J001') {
                    state.initialSearch = false;
                    toast.warn("Please enter all required information to view the patient’s account");
                } else if (response?.ResponseDetails?.ResponseCode == '007') {
                    if (state.searchPatientDetails.dob != '' && (state.searchPatientDetails.ssn != '' || state.searchPatientDetails.alienNumber != '')) {
                        state.newPatient = true;
                        state.createNewPatientModal = true;
                        toast.warn("Patient does not exist, Please create new patient");
                    } else {
                        state.initialSearch = false;
                        toast.warn("Please enter all required information to view the patient’s account");
                    }
                }
                else if (response?.ResponseDetails?.ResponseCode == '010') {
                    state.patientDetails.firstName = response?.ResponseDetails?.pyFirstName;
                    state.patientDetails.lastName = response?.ResponseDetails?.pyLastName;
                    state.patientDetails.dob = `${response?.ResponseDetails?.DateOfBirth.substring(5, 7)}/${response?.ResponseDetails?.DateOfBirth.substring(8, 10)}/${response?.ResponseDetails?.DateOfBirth.substring(0, 4)}`;
                    state.patientDetails.ssn = typeof response?.ResponseDetails?.SocialSecurityNumber != 'undefined' ? response?.ResponseDetails?.SocialSecurityNumber : '';
                    state.patientDetails.alienNumber = typeof response?.ResponseDetails?.AlienNumber != 'undefined' ? response?.ResponseDetails?.AlienNumber : '';
                    state.patientDetails.patientId = response?.ResponseDetails?.PatientID;
                    state.patientDetails.patientIdFAF = typeof response?.ResponseDetails?.FAFRefID != 'undefined' ? response?.ResponseDetails?.FAFRefID : '';
                    state.patientDetails.patientIdCPR = typeof response?.ResponseDetails?.CPRRefID != 'undefined' ? response?.ResponseDetails?.CPRRefID : '';
                    state.patientDetails.patientIdCASE = typeof response?.ResponseDetails?.CaseMgtRefID != 'undefined' ? response?.ResponseDetails?.CaseMgtRefID : '';
                    state.patientDetails.phoneNumber = response?.ResponseDetails?.PrimaryPhone;
                    state.patientDetails.email = response?.ResponseDetails?.PrimaryEmail;
                    state.patientDetails.fullAddress = `${response?.ResponseDetails?.Address[0]?.AddressLine1}, ${(response?.ResponseDetails?.Address[0]?.AddressLine2 != "" && response?.ResponseDetails?.Address[0]?.AddressLine2 != undefined) ? (response?.ResponseDetails?.Address[0]?.AddressLine2 + ",") : ""} ${response?.ResponseDetails?.HomeCity}, ${response?.ResponseDetails?.HomeState} ${response?.ResponseDetails?.HomeZipCode}`;
                    state.patientDetails.isSSN = state.patientDetails.ssn == '' ? false : true;

                    // toast.success(response?.ResponseDetails?.ResponseMessage);
                    state.patientDetails.caseID = response?.ResponseDetails?.CaseMgtRefID || "";
                    state.displayPatientCard = true;
                } else {
                    toast.error(response?.ResponseDetails?.ResponseMessage);
                }
                return
            })
            .addCase(searchPartnerPatient.rejected, (state, action) => {
            })

            //  Patient Details from D_Member

            .addCase(getPatientDetails.pending, (state, action) => {
            })
            .addCase(getPatientDetails.fulfilled, (state, action) => {
                let response = action.payload.res;
                state.IsPatientLocked = action.payload.res?.IsPatientLocked == "true" ? true : false || false
                state.routeToPrescreen = true;
                state.patientInformation.partnerPatientId = state.patientDetails.patientId;
                state.patientInformation.programSpecificPatientId = response?.ID || "";
                state.patientInformation.Program = action.payload.program || "";
                state.patientInformation.firstName = response?.pyFirstName || "";
                state.patientInformation.lastName = response?.pyLastName || "";
                state.patientInformation.dateOfBirth = response?.DateOfBirth || "";
                state.patientInformation.ssn = response?.SocialSecurityNumber || "";
                state.patientInformation.alienNumber = response?.AlienNumber || "";
                state.patientInformation.address.addressLine1 = response?.Address[0]?.AddressLine1 || "";
                state.patientInformation.address.addressLine2 = response?.Address[0]?.AddressLine2 || "";
                state.patientInformation.address.city = response?.Address[0]?.City || "";
                state.patientInformation.address.state = response?.Address[0]?.State || "";
                state.patientInformation.address.zipCode = response?.Address[0]?.ZipCode || "";
                // contact information
                state.patientInformation.contactDetails.methodOfContact = response?.CorrPreferences || "";
                state.patientInformation.contactDetails.preferedLanguage = response?.PreferredLanguage || "";
                state.patientInformation.contactDetails.email = response?.PrimaryEmail || "";
                state.patientInformation.contactDetails.emailType = response?.EmailType || "";
                state.patientInformation.contactDetails.emailOwner = response?.EmailOwner || "";
                state.patientInformation.contactDetails.phoneType = response?.PhoneCommunication[0]?.PhoneType || "";
                state.patientInformation.contactDetails.phoneNumber = response?.PhoneCommunication[0]?.PhoneNumber || "";

                //Checking Patient is Major
                if (response.DateOfBirth) {
                    const today = new Date()
                    const birthDate = new Date(response?.DateOfBirth);
                    let age = today.getFullYear() - birthDate.getFullYear();
                    const monthDiff = today.getMonth() - birthDate.getMonth();
                    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                        age--;
                    }
                    state.patientInformation.hasGuardian = age < 18
                }
                // Guardian Information
                if (response?.HasGuardianInfo == 'true') {
                    state.patientInformation.guardianDetails.firstName = response?.GuardianInformation.pyFirstName || "";
                    state.patientInformation.guardianDetails.lastName = response?.GuardianInformation.pyLastName || "";
                    state.patientInformation.guardianDetails.suffix = response?.GuardianInformation.pyNameSuffix || "";
                    state.patientInformation.guardianDetails.alienNumber = response?.GuardianInformation.AlienNumber || "";
                    state.patientInformation.guardianDetails.ssn = response?.GuardianInformation.SocialSecurityNumber || "";
                    state.patientInformation.guardianDetails.dateOfBirth = response?.GuardianInformation.DateOfBirth || "";
                    state.patientInformation.guardianDetails.relationshipToPatient = response?.GuardianInformation.RelationshipToPatient || "";
                    state.patientInformation.guardianDetails.employementStatus = response?.GuardianInformation.EmploymentStatus || "";
                    state.patientInformation.guardianDetails.email = response?.GuardianInformation.pyEmail1 || "";
                    state.patientInformation.guardianDetails.emailType = response?.GuardianInformation.pyEmail1Type || "";
                    if (response?.GuardianInformation.IsAddressSameAsPatient == 'false') {
                        state.patientInformation.guardianDetails.isAddressSameAsPatient = response?.GuardianInformation.IsAddressSameAsPatient == 'true';
                        state.patientInformation.guardianDetails.address.addressLine1 = response?.GuardianInformation.GuardianAddressList[0]?.AddressLine1 || ""
                        state.patientInformation.guardianDetails.address.addressLine2 = response?.GuardianInformation.GuardianAddressList[0]?.AddressLine2 || ""
                        state.patientInformation.guardianDetails.address.city = response?.GuardianInformation.GuardianAddressList[0]?.City || ""
                        state.patientInformation.guardianDetails.address.state = response?.GuardianInformation.GuardianAddressList[0]?.State || ""
                        state.patientInformation.guardianDetails.address.zipCode = response?.GuardianInformation.GuardianAddressList[0]?.ZipCode || ""
                    }
                    if (response?.GuardianInformation.IsContactSameAsPatient == 'false') {
                        state.patientInformation.guardianDetails.isPhoneNumberSameAsPatient = response?.GuardianInformation.IsContactSameAsPatient == 'true';
                        state.patientInformation.guardianDetails.PhoneCommunication.phoneNumber = response?.GuardianInformation.PhoneCommunication[0]?.PhoneNumber || "";
                        state.patientInformation.guardianDetails.PhoneCommunication.phoneType = response?.GuardianInformation.PhoneCommunication[0]?.PhoneType || "";

                    }
                }
                // Additional Information
                state.patientInformation.additionalInformation.gender = response?.GenderCode || ""
                state.patientInformation.additionalInformation.employementStatus = response?.EmploymentStatus || ""
                state.patientInformation.additionalInformation.veteran = response?.VeteranClassification || ""
                state.patientInformation.additionalInformation.maritalStatus = response?.MaritalStatus || ""
                state.patientInformation.additionalInformation.housHoldSize = response?.HouseholdSize || ""
                state.patientInformation.additionalInformation.race = response?.Race || []
                state.patientInformation.additionalInformation.raceOther = response?.OtherRace || ""
                state.patientInformation.additionalInformation.hispanicOrgin = response?.HispanicOrLatino || ""

                //Authorized Person
                if (response?.AuthPersonList?.length > 0) {
                    state.isAuthorizedPersonAvailable = response.IsAuthPersonAvailable == "true"
                    response?.AuthPersonList?.map((authPerson, i) => {
                        state.authorizedPerson = {
                            ...state.authorizedPerson,
                            [i]: {
                                firstName: { value: authPerson.pyFirstName || "", isValid: true },
                                lastName: { value: authPerson.pyLastName || "", isValid: true },
                                suffix: { value: authPerson?.pyNameSuffix || "", isValid: true },
                                relationshipToPatient: { value: authPerson.RelationshipToPatient, isValid: true },
                                addressLine1: { value: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.AddressLine1, isValid: true },
                                addressLine2: { value: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.AddressLine2, isValid: true },
                                city: { value: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.City, isValid: true },
                                state: { value: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.State, isValid: true },
                                zipcode: { value: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.ZipCode, isValid: true },
                                phoneType: { value: authPerson.IsContactSameAsPatient == "true" ? "" : authPerson.PhoneType, isValid: true },
                                phoneNumber: { value: authPerson.IsContactSameAsPatient == "true" ? "" : authPerson.PhoneNumber, isValid: true },
                                isAddressChecked: authPerson.IsAddressSameAsPatient == "true",
                                isPhoneNumberChecked: authPerson.IsContactSameAsPatient == "true",
                                isAddressVerified: false,
                                isCopySent: authPerson.IsToReceiveEmail == "true",
                                email: { value: authPerson?.pyEmail1 || "", isValid: true },
                                hasDuplicate: false,
                                smartyStreetMatches: {
                                    NoMatch: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.NoMatch,
                                    PartialMatch: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.PartialMatch,
                                    SecInfoNotMatch: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.SecInfoNotMatch,
                                    ExactMatch: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.ExactMatch,
                                },
                                ss_msg_cls: '',
                                ss_msg: '',
                            }
                        }
                    })
                }
            })
            .addCase(getPatientDetails.rejected, (state, action) => {
            })


            //  Create New Patient in Partner

            .addCase(createPatientInPartner.pending, (state, action) => {
                // toast.warn('Pending')
            })
            .addCase(createPatientInPartner.fulfilled, (state, action) => {

                let response = action.payload;
                if (response?.ResponseDetails?.ResponseCode == "010") {
                    state.patientDetails.firstName = response?.NewPartnerPatient?.pyFirstName;
                    state.patientDetails.lastName = response?.NewPartnerPatient?.pyLastName;
                    state.patientDetails.dob = `${response?.NewPartnerPatient?.DateOfBirth.substring(5, 7)}/${response?.NewPartnerPatient?.DateOfBirth.substring(8, 10)}/${response?.NewPartnerPatient?.DateOfBirth.substring(0, 4)}`;
                    state.patientDetails.ssn = response?.NewPartnerPatient?.SocialSecurityNumber;
                    state.patientDetails.alienNumber = response?.NewPartnerPatient?.AlienNumber;
                    state.patientDetails.patientId = response?.ResponseDetails?.PatientID;
                    state.patientDetails.phoneNumber = response?.NewPartnerPatient?.PhoneCommunication[0]?.PhoneNumber;
                    state.patientDetails.email = response?.NewPartnerPatient.PrimaryEmail;
                    state.patientDetails.fullAddress = `${response?.NewPartnerPatient?.Address[0]?.AddressLine1}, ${(response?.NewPartnerPatient?.Address[0]?.AddressLine2 != "" && response?.NewPartnerPatient?.Address[0]?.AddressLine2 != undefined) ? (response?.NewPartnerPatient?.Address[0]?.AddressLine2 + ",") : ""} ${response?.NewPartnerPatient?.Address[0]?.City}, ${response?.NewPartnerPatient?.Address[0]?.State} ${response?.NewPartnerPatient?.Address[0]?.ZipCode}`;
                    state.patientDetails.addressLine1 = response?.NewPartnerPatient?.Address[0]?.AddressLine1;
                    state.patientDetails.addressLine2 = response?.NewPartnerPatient?.Address[0]?.AddressLine2;
                    state.patientDetails.state = response?.NewPartnerPatient?.Address[0]?.State;
                    state.patientDetails.city = response?.NewPartnerPatient?.Address[0]?.City;
                    state.patientDetails.zipCode = response?.NewPartnerPatient?.Address[0]?.ZipCode;
                    state.patientDetails.isSSN = state.patientDetails.ssn == '' ? false : true;
                    state.patientDetails.caseID = response?.ResponseDetails?.CaseMgtRefID || "";
                    state.displayPatientCard = true;
                    state.createNewPatientModal = false;
                    toast.success('Patient created successfully')
                } else {
                    state.createNewPatientModal = false;
                    toast.error(response?.ResponseDetails?.ResponseMessage);
                }
                return
            })
            .addCase(createPatientInPartner.rejected, (state, action) => {
            })

            //  Search Patient By Program
            .addCase(getSearchPatientByProgram.pending, (state, action) => {
            })
            .addCase(getSearchPatientByProgram.fulfilled, (state, action) => {
                let response = action.payload.res;
                if (response?.ResponseDetails?.ResponseCode == '010') {
                    state.patientInformation.programSpecificPatientId = response?.ResponseDetails?.PatientID;
                    state.patientInformation.Program = action.payload.program;
                    state.patientInformation.partnerPatientId = action.payload.patientPartnerId;
                    state.patientInformation.existingPatient = true;
                    state.getMemberLookupData = true;
                    // state.routeToPrescreen = true;
                    return
                } else if (response?.ResponseDetails?.ResponseCode == '007') {
                    state.patientInformation.existingPatient = false;
                    state.patientInformation.Program = action.payload.program;
                    state.patientInformation.partnerPatientId = action.payload.patientPartnerId;
                    state.getPartnerMemberLookupData = true;
                } else {
                    toast.error(response?.ResponseDetails?.ResponseMessage);
                }


            })
            .addCase(getSearchPatientByProgram.rejected, (state, action) => {
            })


            //  Partner Member Table Patient data
            .addCase(getPatientMemberInPartner.pending, (state, action) => {
            })
            .addCase(getPatientMemberInPartner.fulfilled, (state, action) => {
                let response = action.payload.res;
                state.routeToPrescreen = true;
                state.patientInformation.partnerPatientId = state.patientDetails.patientId
                state.patientInformation.programSpecificPatientId = '';
                state.patientInformation.Program = action.payload.program;
                state.patientInformation.firstName = response?.pyFirstName || "";
                state.patientInformation.lastName = response?.pyLastName || "";
                state.patientInformation.dateOfBirth = response?.DateOfBirth || "";
                state.patientInformation.ssn = typeof response?.SocialSecurityNumber != 'undefined' ? response.SocialSecurityNumber : '';
                state.patientInformation.alienNumber = response?.AlienNumber || "";
                state.patientInformation.address.addressLine1 = response?.Address[0]?.AddressLine1 || "";
                state.patientInformation.address.addressLine2 = response?.Address[0]?.AddressLine2 || "";
                state.patientInformation.address.city = response?.Address[0]?.City || "";
                state.patientInformation.address.state = response?.Address[0]?.State || "";
                state.patientInformation.address.zipCode = response?.Address[0]?.ZipCode || "";
                // contact information
                state.patientInformation.contactDetails.methodOfContact = response?.CorrPreferences || "";
                state.patientInformation.contactDetails.preferedLanguage = response?.PreferredLanguage || "";
                state.patientInformation.contactDetails.email = response?.PrimaryEmail || "";
                state.patientInformation.contactDetails.emailType = response?.EmailType || "";
                state.patientInformation.contactDetails.emailOwner = response?.EmailOwner || "";
                state.patientInformation.contactDetails.phoneType = response?.PhoneCommunication[0]?.PhoneType || "";
                state.patientInformation.contactDetails.phoneNumber = response?.PhoneCommunication[0]?.PhoneNumber || "";

                //Checking Patient is Major
                if (response?.DateOfBirth) {
                    const today = new Date()
                    const birthDate = new Date(response?.DateOfBirth);
                    let age = today.getFullYear() - birthDate.getFullYear();
                    const monthDiff = today.getMonth() - birthDate.getMonth();
                    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                        age--;
                    }
                    state.patientInformation.hasGuardian = age < 18
                }
                // Guardian Information
                if (response?.HasGuardianInfo == 'true') {
                    state.patientInformation.guardianDetails.firstName = response?.GuardianInformation.pyFirstName || "";
                    state.patientInformation.guardianDetails.lastName = response?.GuardianInformation.pyLastName || "";
                    state.patientInformation.guardianDetails.suffix = response?.GuardianInformation.pyNameSuffix || "";
                    state.patientInformation.guardianDetails.alienNumber = response?.GuardianInformation.AlienNumber || "";
                    state.patientInformation.guardianDetails.ssn = response?.GuardianInformation.SocialSecurityNumber || "";
                    state.patientInformation.guardianDetails.dateOfBirth = response?.GuardianInformation.DateOfBirth || "";
                    state.patientInformation.guardianDetails.relationshipToPatient = response?.GuardianInformation.RelationshipToPatient || "";
                    state.patientInformation.guardianDetails.employementStatus = response?.GuardianInformation.EmploymentStatus || "";
                    state.patientInformation.guardianDetails.email = response?.GuardianInformation.pyEmail1 || "";
                    state.patientInformation.guardianDetails.emailType = response?.GuardianInformation.pyEmail1Type || "";
                    if (response?.GuardianInformation.IsAddressSameAsPatient == 'true') {
                        state.patientInformation.guardianDetails.isAddressSameAsPatient = true || "";
                        state.patientInformation.guardianDetails.address.addressLine1 = response?.GuardianInformation.GuardianAddressList[0]?.AddressLine1 || ""
                        state.patientInformation.guardianDetails.address.addressLine2 = response?.GuardianInformation.GuardianAddressList[0]?.AddressLine2 || ""
                        state.patientInformation.guardianDetails.address.city = response?.GuardianInformation.GuardianAddressList[0]?.City || ""
                        state.patientInformation.guardianDetails.address.state = response?.GuardianInformation.GuardianAddressList[0]?.State || ""
                        state.patientInformation.guardianDetails.address.zipCode = response?.GuardianInformation.GuardianAddressList[0]?.ZipCode || ""
                    }
                    if (response?.GuardianInformation.IsContactSameAsPatient == 'true') {
                        state.patientInformation.guardianDetails.isPhoneNumberSameAsPatient = true || "";
                        state.patientInformation.guardianDetails.PhoneCommunication.phoneNumber = response?.GuardianInformation.PhoneCommunication[0]?.PhoneNumber || "";
                        state.patientInformation.guardianDetails.PhoneCommunication.phoneType = response?.GuardianInformation.PhoneCommunication[0]?.PhoneType || "";

                    }
                }
                // Additional Information
                state.patientInformation.additionalInformation.gender = response?.GenderCode || ""
                state.patientInformation.additionalInformation.employementStatus = response?.EmploymentStatus || ""
                state.patientInformation.additionalInformation.veteran = response?.VeteranClassification || ""
                state.patientInformation.additionalInformation.maritalStatus = response?.MaritalStatus || ""
                state.patientInformation.additionalInformation.housHoldSize = typeof response?.HouseholdSize != 'undefined' ? response?.HouseholdSize : ''
                state.patientInformation.additionalInformation.race = typeof response?.Race != 'undefined' ? response?.Race : [];
                state.patientInformation.additionalInformation.raceOther = response?.OtherRace || ""
                state.patientInformation.additionalInformation.hispanicOrgin = response?.HispanicOrLatino || ""
                //Authorized Person
                if (response?.AuthPersonList?.length > 0) {
                    state.isAuthorizedPersonAvailable = response.IsAuthPersonAvailable == "true"
                    response?.AuthPersonList?.map((authPerson, i) => {
                        state.authorizedPerson = {
                            ...state.authorizedPerson,
                            [i]: {
                                firstName: { value: authPerson.pyFirstName || "", isValid: true },
                                lastName: { value: authPerson.pyLastName || "", isValid: true },
                                suffix: { value: authPerson?.pyNameSuffix || "", isValid: true },
                                relationshipToPatient: { value: authPerson.RelationshipToPatient, isValid: true },
                                addressLine1: { value: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.AddressLine1 || "", isValid: true },
                                addressLine2: { value: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.AddressLine2 || "", isValid: true },
                                city: { value: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.City || "", isValid: true },
                                state: { value: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.State || "", isValid: true },
                                zipcode: { value: authPerson.IsAddressSameAsPatient == "true" ? "" : authPerson?.AuthPersonAddressList[0]?.ZipCode || "", isValid: true },
                                phoneType: { value: authPerson.IsContactSameAsPatient == "true" ? "" : authPerson.PhoneType || "", isValid: true },
                                phoneNumber: { value: authPerson.IsContactSameAsPatient == "true" ? "" : authPerson.PhoneNumber || "", isValid: true },
                                isAddressChecked: authPerson.IsAddressSameAsPatient == "true",
                                isPhoneNumberChecked: authPerson.IsContactSameAsPatient == "true",
                                isAddressVerified: false,
                                isCopySent: authPerson.IsToReceiveEmail == "true",
                                email: { value: authPerson?.pyEmail1 || "", isValid: true },
                                hasDuplicate: false,
                                smartyStreetMatches: {
                                    NoMatch: authPerson.IsAddressSameAsPatient == "true" ? false : authPerson?.AuthPersonAddressList[0]?.NoMatch || false,
                                    PartialMatch: authPerson.IsAddressSameAsPatient == "true" ? false : authPerson?.AuthPersonAddressList[0]?.PartialMatch || false,
                                    SecInfoNotMatch: authPerson.IsAddressSameAsPatient == "true" ? false : authPerson?.AuthPersonAddressList[0]?.SecInfoNotMatch || false,
                                    ExactMatch: authPerson.IsAddressSameAsPatient == "true" ? false : authPerson?.AuthPersonAddressList[0]?.ExactMatch || false,
                                },
                                ss_msg_cls: '',
                                ss_msg: '',
                            }
                        }
                    })
                }
                return
            })
            .addCase(getPatientMemberInPartner.rejected, (state, action) => {
            })
            .addCase(getFatchPhoneNumber.pending, (state, action) => {
            })
            .addCase(getFatchPhoneNumber.fulfilled, (state, action) => {
                 state.dyNumber=action?.payload?.res?.pxResults[0]?.PhoneNumber
            })
            .addCase(getFatchPhoneNumber.rejected, (state, action) => {
            })

    },
})

export const { patientInfo } = state => state.patientSearchSlice.patientInformation;
export const { setStoreSearchPatientDetails, setAllowCaseCreation, resetPatientSearch, setStoreInitialSearch, setStoreDisplayPatientCard, setStoreCreateNewPatientModal, setGetMemberLookupData, setGetPartnerMemberLookupData, setRouteToPrescreen, personalInfoData, authorizedPersonData, insuranceInfoData, preQualData, setProgramSpecificPatientId, IsPatientLockedReset } = patientSearchSlice.actions
export default patientSearchSlice.reducer